<mat-toolbar color="primary">
  <span id="beslutning-opprett-dialog-tittel">
    @if (erForslag) {
        {{ "Nytt forslag til beslutning"|translate }}
      } @else {
      {{ "Ny beslutning"|translate }}
    }
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<form [formGroup]="skjema" (ngSubmit)="opprett()">
  <mat-dialog-content class="skjema">
    <beslutning-skjema [skjema]="skjema" [gruppeId]="gruppeId"/>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
    <button mat-raised-button color="primary" type="submit" cdkFocusInitial
            [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()"
            spinnerTekst="{{'Oppretter...'|translate}}" data-testid="lagre">
      {{ 'Opprett'|translate }}
    </button>
  </mat-dialog-actions>
</form>
